import { ServerResponse } from 'http';

const handleListingRedirect = (
    res: ServerResponse | undefined,
    redirectUri: string,
    redirectCode: number
) => {
    if (res) {
        res.writeHead(redirectCode, {
            Location: redirectUri
        });
        res.end();
    } else {
        window.location.assign(redirectUri);
    }
};

export default handleListingRedirect;
